import { IconButton } from '@mui/material';
import classNames from 'classnames';

import styles from './styles.module.css';

const DotIcon = ({ checked = false, theme = 'cultivio' }) => {
    const classes = classNames(styles.dot, theme && checked ? styles[`dot-${theme}`] : undefined);

    return (
        <IconButton size='small'>
            <span className={classes} />
        </IconButton>
    );
};

export default DotIcon;
